import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OfferCardDataPrice } from '../offer-card-data.model';
import { Currency } from 'projects/common/model/landingModel';
import { LandingModelService } from 'projects/common/services/landingModel.service';

@Component({
  selector: 'pricebox-with-points',
  template: `
    <div class="pricebox" [ngClass]="{'inside-cluster' : !!moduleId, 'eva-3-pricebox-cluster': !!moduleId}">

      <div class="pricebox__points-container">
      <dual-promo *ngIf="price.promotions_list"
                  [promotionsList]="price.promotions_list | reverseArray"
                  [position]="positionLabelClassName"></dual-promo>
        <div *ngIf="price.prepaid_price_in_points">
          <p class="pricebox__points-message">{{ price.message }}</p>
          <div class="pricebox__points-description">
            <span class="pricebox__points-amount">{{price.prepaid_price_in_points.toLocaleString(locale.replace('_', '-'))}}</span>
            <div class="pricebox__points-info">
              <span class="pricebox__points-label">{{loyaltyPointsName}}</span>
              <span class="pricebox__points-wl">{{companyName}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="pricebox__price-container">
        <div class="pricebox__price-description">
          <span class="pricebox__price-text">{{ 'offers.price' | translate }}</span>
          <span class="pricebox__price-currency">{{currency.symbol}}</span>
          <span class="pricebox__price-amount">{{price.total_amount}}</span>
        </div>
        <div *ngIf="price.points"
              class="pricebox__price-points">
          {{'offers.points.labelWithWL' | translate: {points: price.points.toLocaleString(locale.replace('_', '-')), pointsName: loyaltyPointsName, wl: companyName} }}
        </div>

        <div
          *ngIf="price.tax_message"
          class="pricebox__price-tax-message"
        >
          {{ price.tax_message }}
        </div>
      </div>

      <div class="pricebox__action" *ngIf="moduleId">
        <eva-button [moduleId]="moduleId"
                    [nofollow]="true"
                    [newTab]="true"
                    [options]="{type: '-primary', size:'-md', link_text: (buttonTextKey) | translate, as_span: true}"
        ></eva-button>
      </div>
    </div>
  `,
  styleUrls: ['./pricebox-with-points.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PriceboxWithPointsComponent implements OnInit {
  @Input() price: OfferCardDataPrice;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() positionLabelClassName: '-top-left' | '-top-right' | '-bottom-left' | '-bottom-right' = '-top-right';
  @Input() moduleId?: string;
  @Input() sboxAutocomplete?: boolean;
  @Input() product?: string;

  isHotelOrVr: boolean = false;
  buttonTextKey: string;
  // Harcodeado por el momento hasta que sepamos la forma de obtener el partner
  companyName: string = 'BBVA';
  loyaltyPointsName: string = 'test';

  constructor(private landingModelService: LandingModelService) {}

  ngOnInit(): void {
    this.loyaltyPointsName = this.landingModelService.getLandingModel().keywordsMap['HOME_WL_POINTS_NAME']?.toLocaleLowerCase();
    this.isHotelOrVr = !!this.product && ['hotels', 'vacation_rentals'].includes(this.product);
    this.buttonTextKey = (this.sboxAutocomplete && this.isHotelOrVr) ? 'offers.buttons.validDates.absolute' : 'offers.buttons.seeDetail';
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.moduleId) {
      if (window.innerWidth < 1024) {
        this.positionLabelClassName = '-top-right';
      } else {
        this.positionLabelClassName = '-top-left';
      }
    }
  }

}
